import {
  VIEW_USER_MANAGEMENT_SUCCESS,
  VIEW_USER_MANAGEMENT_FAILED,
  LOADING_VIEW_USER_MANAGEMENT,
  NETWORK_ERROR_VIEW_USER_MANAGEMENT,
  RESET_VIEW_USER_MANAGEMENT,
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetViewUserList = () => {
  return { type: RESET_VIEW_USER_MANAGEMENT };
};

const getViewUserManagementList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_VIEW_USER_MANAGEMENT });
    await partnerServices
      .post("viewUserMngtList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "Success":
            dispatch(getViewUserManagementListsuccess(res.data));
            break;
          default:
            dispatch(getViewUserManagementListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({ type: NETWORK_ERROR_VIEW_USER_MANAGEMENT, payload: err });
      });
  };

function getViewUserManagementListsuccess(data) {
  return {
    type: VIEW_USER_MANAGEMENT_SUCCESS,
    payload: data,
  };
}
function getViewUserManagementListFailed(data) {
  return {
    type: VIEW_USER_MANAGEMENT_FAILED,
    payload: data,
  };
}

export { resetViewUserList, getViewUserManagementList };
